import Vue from 'vue'
import App from './App.vue'
import { Pagination, DatePicker, Select, Option, Loading, Button, Table, TableColumn, Popover, Dialog, Alert, Checkbox, RadioGroup, Radio, Switch, Input, InputNumber, Form, FormItem, Autocomplete, Tabs, TabPane, Row, Col, Upload, Progress, Card, Collapse, CollapseItem, Dropdown, DropdownMenu, DropdownItem, RadioButton, CheckboxGroup, Rate, Tooltip, Badge, Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router/router'
import store from './store/store'
import Toast from './plugins/toast/toast.js'
import Tips from './plugins/dialog/dialog.js'
import 'babel-polyfill'
// css loader
import './css/common.css'
import './css/color.css'
import './css/animate.css'
import './css/loading.css'
import './css/toast.css'
import './css/font/iconfont.css'
import './css/style.css'


Vue.prototype.$ELEMENT = { size: 'small' }
Vue.use(Pagination)
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Option)
Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Popover)
Vue.use(Dialog)
Vue.use(Alert)
Vue.use(Checkbox)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Switch)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Autocomplete)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Row)
Vue.use(Col)
Vue.use(Upload)
Vue.use(Progress)
Vue.use(Card)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(RadioButton)
Vue.use(CheckboxGroup)
Vue.use(Rate)
Vue.use(Tooltip)
Vue.use(Badge)
Vue.use(Loading)
Vue.use(Toast)
Vue.use(Tips)

Vue.prototype.$message = Message;

new Vue({
  router,
  render: h => h(App),
  store
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js